import { ChangeDetectionStrategy, Component, computed, inject, input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PAGE } from '../app.routes';
import { APP_CONFIGURATION_TOKEN, ToastService } from '../core';
import { RequestFrom } from '../models';
import { DiaryService } from '../services';
import { BaseComponent } from '../shared';
import { AnomalyTableComponent } from './anomaly-table';
import { DiaryTableComponent } from './diary-table';
import { SyncronizationComponent } from './syncronization';


/**
 * Component for patient history page.
 */
@Component({
	selector: 'tsp-history',
	imports: [
		SyncronizationComponent,
		AnomalyTableComponent,
		DiaryTableComponent
	],
	templateUrl: './history.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class HistoryComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly router = inject(Router);
	private readonly diarySrv = inject(DiaryService);
	private readonly toastSrv = inject(ToastService);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);
	
	patientGuid = input<string>();
	reqFrom = input<RequestFrom>();

	patient = computed(() => this.diarySrv.patient());
	lastSync = computed(() => this.diarySrv.lastSync());
	isReadonly = computed(() => this.diarySrv.isReadonly());


	ngOnInit(): void {
		if (this.patientGuid()) {
			this.diarySrv.init(this.patientGuid()!).subscribe({
				error: () => this.toastSrv.showError(this.labels().HISTORY_FILTERS_COMPONENT_SEARCH_ERROR)
			});
		} else {
			throw new Error('Patient Guid is required!');
		}
	}

	/**
	 * Navigate to List of Patients page.
	 */
	cancel(): void {
		if (this.reqFrom() === RequestFrom.PATIENT) {
			window.location.href = this.configs.patListSite;
		} else {
			this.router.navigateByUrl(PAGE.PATIENT_LIST);
		}
	}


	ngOnDestroy(): void {
		this.diarySrv.reset();
	}

}
